import { ReactNode } from 'react';

import Drawer from '@mui/material/Drawer';

type ResponsivePanelContainerProps = {
	isMobile: boolean;
	open: boolean;
	onClose: () => void;
	children: ReactNode;
	ariaLabel?: string;
};

/**
 * Hosts the fixed desktop side panels in a full-screen, dismissible drawer on small screens.
 * SidePanelList and SidePanelDetail expose the responsive-side-panel class intentionally so the
 * mobile presentation does not depend on Material UI's generated DOM structure.
 */
export default function ResponsivePanelContainer({ isMobile, open, onClose, children, ariaLabel = 'Details panel' }: ResponsivePanelContainerProps) {
	if (!isMobile) {
		return <>{children}</>;
	}

	return (
		<Drawer
			anchor="right"
			open={open}
			onClose={onClose}
			aria-label={ariaLabel}
			PaperProps={{
				sx: {
					width: '100%',
					maxWidth: '100%',
					'& .responsive-side-panel': {
						width: '100% !important',
						maxWidth: '100%',
						top: '0 !important',
						right: '0 !important',
						bottom: '0 !important',
						borderRadius: 0,
					},
				},
			}}
		>
			{children}
		</Drawer>
	);
}
